// export const API_BASE_URL = 'http://192.168.0.130:9999/xlh/xlh/api';
export const API_BASE_URL = 'http://121.37.140.224:7070/xlhSm/xlh/api';
// export const API_BASE_URL = 'http://eye.bjyxinfo.com';
export const MAX_UPLOAD_SIZE = 10 * 1024 * 1024; // 10 MB
export default {}